import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'web-ui-components/lib/molecules/forms';
import { AccountPoolTablePanel } from 'web-ui-components/lib/finance/accounts';

const consolidatedList = (
  poolAccounts,
  allAccounts,
  redirectToAccountDetail
) => {
  const consolidatedAccountList = [];
  poolAccounts.forEach((poolAccount) => {
    const account = allAccounts.find((acc) => acc.id === poolAccount.accountId);
    if (account) {
      const {
        number,
        metadata: { account_name, display_name },
        product: { name },
      } = account;
      consolidatedAccountList.push({
        ...poolAccount,
        accountLink: {
          accountName: display_name || account_name || name,
          onClick: () => redirectToAccountDetail(account),
        },
        accountNumber: number.split('-')[1],
      });
    }
  });
  return consolidatedAccountList;
};
export const AccountPoolDetailsTable = ({
  allAccounts,
  tableText,
  poolDetails: {
    accounts,
    availableBalance,
    currentBalance,
    currencySymbol,
    totalValues,
    poolName,
  },
  isExpanded,
  onMoreClick,
  redirectToAccountDetail,
}) => {
  const updatedAccountList = consolidatedList(
    accounts,
    allAccounts,
    redirectToAccountDetail
  );
  return (
    <Field>
      <AccountPoolTablePanel
        accountAvailable={availableBalance}
        accountBalance={currentBalance}
        currencySymbol={currencySymbol}
        isExpanded={isExpanded}
        moreOnClick={onMoreClick}
        data={updatedAccountList}
        totalValues={totalValues}
        totalAccounts={updatedAccountList.length}
        tableBody={tableText}
        poolName={poolName}
      />
    </Field>
  );
};
AccountPoolDetailsTable.propTypes = {
  poolDetailProps: PropTypes.shape({ poolDetail: PropTypes.object }).isRequired,
  isExpanded: PropTypes.bool,
  allAccounts: PropTypes.array,
};
